import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconRegularViewDashboard = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 25,
	viewBox: "0 0 24 25",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M22 12.197c0 5.567-4.477 10.079-10 10.079S2 17.764 2 12.196C2 6.63 6.477 2.119 12 2.119S22 6.63 22 12.197zm-9.063 1.445v-8.06A.94.94 0 0 0 12 4.639a.94.94 0 0 0-.938.945v8.059A2.51 2.51 0 0 0 9.5 15.976c0 1.39 1.121 2.52 2.5 2.52s2.5-1.13 2.5-2.52a2.51 2.51 0 0 0-1.563-2.334zM7.625 9.047c.691 0 1.25-.563 1.25-1.26 0-.696-.559-1.26-1.25-1.26s-1.25.564-1.25 1.26c0 .697.559 1.26 1.25 1.26zm-1.875 1.89c-.69 0-1.25.563-1.25 1.26 0 .697.56 1.26 1.25 1.26.691 0 1.25-.563 1.25-1.26 0-.697-.559-1.26-1.25-1.26zm12.5 2.52c.691 0 1.25-.563 1.25-1.26 0-.697-.559-1.26-1.25-1.26S17 11.5 17 12.197c0 .697.559 1.26 1.25 1.26zm-1.875-6.93c-.691 0-1.25.564-1.25 1.26 0 .697.559 1.26 1.25 1.26s1.25-.563 1.25-1.26c0-.696-.559-1.26-1.25-1.26z",
		fill: "currentColor",
		fillRule: "nonzero"
	})
});
export default SvgIconRegularViewDashboard;
